// src/components/Production.js
import { NavLink, Outlet, useLocation } from "react-router-dom";

function CrudCategoryPage (
  props
) {
  const location = useLocation();
  const pathname = location.pathname;
  // Mark "Production Scheduling" as active if the current URL is "/production" or "/production/scheduling"
  const isPathActive =
    pathname === props.rootPath || pathname === props.rootDefaultPath;
// console.log(props)
    // console.log(item);
  return (
    <div className="page-container">
      <aside>
        <ul>
          { props.item.map((item, idx) => 
            <li key={item.entity}>
            <NavLink
              to={item.entity}
              end
              className={({ isActive }) => (idx === 0 && isPathActive) || (idx > 0 && isActive) ? "active" : ""}
            >
              {item.title}
            </NavLink>
          </li>
          )}
        </ul>
      </aside>
      <main>
        {/* Renders the selected left nav child component */}
        <Outlet />
      </main>
    </div>
  );
}

export default CrudCategoryPage;
